//shop
import React, { useMemo, useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { IoSearchOutline, IoHeartOutline, IoFilterOutline, IoChevronDown, IoChevronUp } from "react-icons/io5";
import { FaCartPlus, FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";
import styled from "styled-components";
import StripePayment from "./Stripe/StripePayment";
import { fetchWithTimeout } from "../utils/fetchWithTimeout";
import { useTranslation } from 'react-i18next';
import '../styles/scrollbar.css';
import image from './Assets/whaat.png';
import crown from './Assets/crown.png';
import gem from './Assets/gem.png';
import leftarrow from './Assets/left-arrow.png';
import rightarrow from './Assets/right-arrow.png';
import instagram from "./Assets/bottom_pic/xianhe_ig.png";
import facebook from "./Assets/bottom_pic/xianhe_fb.png";
import youtube from "./Assets/bottom_pic/xianhe_yt.png";
import close from "./Assets/close.png";
import amulet from './Assets/Xianhe New Assets/copy.png';
import imgAmuplus from './Assets/Xianhe New Assets/shop-images/A-MU collection.png';
import imgThewheel from './Assets/Xianhe New Assets/shop-images/Wheel collection.png';
import imgYourstyle from './Assets/Xianhe New Assets/shop-images/your style collection.png';
import imgLivingedit from './Assets/Xianhe New Assets/shop-images/living edit collection.jpg';

const NAV_IMAGES = {
  amuplus: imgAmuplus,
  thewheel: imgThewheel,
  yourstyle: imgYourstyle,
  thelivingedit: imgLivingedit,
};

const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px clamp(12px, 6vw, 118px) 40px;
  box-sizing: border-box;
  background-color: #171520;
  //border-radius: 15px;
  // border: 1px solid rgba(223, 189, 105, 0.22);
  @media (max-height: 760px) {
    padding: 16px clamp(10px, 4vw, 56px) 24px;
  }
  @media (max-width: 768px) {
    padding: 16px 12px 40px;
  }
`;
const Sidebar = styled.aside`
  width: 280px;
  background-color: #000;
  padding: 14px 12px 18px;
  border-right: 1px solid #dfbd69;
  box-sizing: border-box;
  box-shadow: 4px 0 12px -6px rgba(0, 0, 0, 0.4);

  @media (max-width: 900px) {
    width: 250px;
  }
  @media (max-width: 768px) {
    width: 100%;
    border-right: none;
    border-bottom: 1px solid #dfbd69;
    display: block;
    padding: 10px 10px 12px;
    scrollbar-width: none; /* Firefox */
  }
  @media (max-width: 768px) {
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;
const SidebarSectionTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #dfbd69;
  margin: 10px 6px 8px;
`;

const SidebarButton = styled.button`
  display: block;
  padding: 9px 10px;
  text-align: left;
  background: ${(props) => (props.isActive ? "#1a1a1a" : "transparent")};
  border: 1px solid ${(props) => (props.isActive ? "#dfbd69" : "#444")};
  cursor: pointer;
  width: 100%;
  margin: 6px 0;
  color: #dfbd69;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  transition: background 0.2s ease, border-color 0.2s ease;
  &:hover,
  &:focus-visible {
    background: #242424;
    outline: none;
  }
`;

const SidebarInlineRow = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding: 0 6px;
`;

const Pill = styled.button`
  appearance: none;
  border: 1px solid ${(props) => (props.isActive ? "#dfbd69" : "#444")};
  background: ${(props) => (props.isActive ? "#1a1a1a" : "transparent")};
  color: #dfbd69;
  border-radius: 999px;
  padding: 6px 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  &:hover,
  &:focus-visible {
    background: #242424;
    outline: none;
  }
`;
const FilterLabel = styled.label`
  margin-right: 10px;
  color: #dfbd69;
`;
const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #444;
  border-radius: 8px;
  padding: 8px 10px;
  background: #0a0a0a;
  svg {
    color: #dfbd69;
    flex-shrink: 0;
  }
`;
const FilterBarWrapper = styled.div`
  width: 100%;
  max-width: 1240px;
  margin: 0 auto 20px;
  border: 1px solid rgba(223, 189, 105, 0.3);
  border-radius: 10px;
  background: #0a031e;
`;
const FilterToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  flex-wrap: wrap;
`;
const FilterToggleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: ${(props) => (props.isActive ? '#1a1a1a' : 'transparent')};
  border: 1px solid #dfbd69;
  color: #dfbd69;
  border-radius: 8px;
  padding: 9px 14px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s ease;
  &:hover,
  &:focus-visible {
    background: rgba(223, 189, 105, 0.12);
    outline: none;
  }
`;
const FilterPanel = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 4px 14px 18px;
  border-top: 1px solid rgba(223, 189, 105, 0.2);
`;
const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 220px;
`;
const FilterGroupTitle = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #dfbd69;
`;
const FilterPillRow = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;
const SearchInput = styled.input`
  background: transparent;
  border: none;
  outline: none;
  color: #fff2d2;
  font-size: 14px;
  width: 100%;
  &::placeholder {
    color: #8a8a8a;
  }
`;
const PriceRangeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 6px;
  margin-bottom: 10px;
`;
const PriceInput = styled.input`
  width: 0;
  flex: 1;
  min-width: 0;
  background: #0a0a0a;
  border: 1px solid #444;
  border-radius: 6px;
  color: #fff2d2;
  padding: 7px 8px;
  font-size: 13px;
  outline: none;
  &:focus {
    border-color: #dfbd69;
  }
`;
const ZoomIcon = styled.div`
  color: gold;
`;
// const HeartIcon = styled.div`
//   color: gold;
// `;

const ProductName = styled.h2`
  font-size: clamp(15px, 1.2vw, 20px);
  margin: 15px auto 15px;   /* was: 10px 0 6px */
  width: 100%;
  max-width: 344px;
  color: #deaf77;
  font-weight: 700;
  font-family: 'PlayfairDisplay', serif; /* heading text */
  line-height: 1.35;
  word-break: break-word;
  hyphens: auto;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: 480px) {
    margin: 12px auto;
  }
`;

// const ProductName = styled.h2`
//   /* Base (small mobile) */
//   font-size: 14px;
//   margin: 30px 0 6px; /* replicate previous inline margin-top */
//   color: gold;
//   font-weight: 700;
//   line-height: 1.2;
//   max-width: 190px;
//   width: 100%;
//   /* Multi‑line truncation (2 lines) */
//   display: -webkit-box;
//   -webkit-box-orient: vertical;
//   -webkit-line-clamp: 2; /* show up to 2 lines */
//   line-clamp: 2;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   word-break: break-word;
//   hyphens: auto;

//   @media (min-width: 360px) {
//     font-size: 15px;
//   }
//   @media (min-width: 480px) {
//     max-width: 220px;
//   }
//   @media (min-width: 768px) {
//     font-size: 16px;
//     max-width: 250px;
//   }
//   @media (min-width: 1200px) {
//     font-size: 17px;
//   }
// `;
const Button = styled.button`
  background-color: #000;
  color: gold;
  border: 1px solid gold;
  padding: 0;
  border-radius: 8px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  margin-bottom: 0;
  margin-left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: background 0.2s ease, transform 0.2s ease;
  touch-action: manipulation;
  &:active {
    transform: scale(0.92);
  }
  &:hover,
  &:focus-visible {
    background: #111;
    outline: none;
  }
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  font-family: Arial, sans-serif;
  background: transparent;
  box-sizing: border-box;
  width: 100%;
`;
const MainContentWrapper = styled.div`
  display: flex;
  flex: 1;
  transition: width 0.3s ease;
  backgroundcolor: black;
  width: ${({ isOpen }) =>
    isOpen
      ? "75%"
      : "100%"}; /* Adjusts width based on whether sidebar is open */

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`;
const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`;
const ProductListContainer = styled.div`
  flex: 1;
  overflow-y: auto;
`;
const ProductList = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  justify-content: center;
  justify-items: center;
  align-items: stretch;
  gap: clamp(12px, 1.8vw, 18px);
  margin: 0;
  width: 100%;
  max-width: 1240px;
  margin-inline: auto;
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (max-width: 520px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;
const ProductCard = styled.div`
  padding: 12px;
  width: min(100%, 380px);
  min-height: clamp(540px, 68vh, 630px);
  background: #0A031E;
  text-align: left;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border: 2px solid rgba(201,168,75,0.4);
  border-radius: 10px;
  transition: transform 0.2s ease, border-color 0.2s ease,
    box-shadow 0.2s ease;
  will-change: transform;
  @media (max-height: 760px) {
    min-height: 520px;
  }
  @media (max-width: 768px) {
    min-height: 0;
  }
  // &:hover {
  //   transform: translateY(-4px);
  //   border-color: #333;
  //   box-shadow: 0 6px 18px -8px rgba(0, 0, 0, 0.6);
  // }
`;
const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 344px;
  aspect-ratio: 344 / 380;
  margin: 0 auto;          /* ← add this */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: #0A031E;
  border-radius: 10px;
  border: 1px solid rgba(223, 189, 105, 0.14);
`;

const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
  border-radius: 10px;
  transition: transform 0.35s ease;
  filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.35));
  ${ProductCard}:hover & {
    transform: scale(1.04);
  }
`;

// Simple in-memory cache so each GIF source is fetched & first frame extracted only once
const gifFrameCache = new Map(); // src -> { frame: dataUrl|string, canCapture:boolean }
const pendingCaptures = new Map(); // src -> Promise

// Component to always pause GIFs by default (show first frame), animate only on hover/tap.
// If frame capture fails, show a static placeholder (not the animated GIF).
const HoverGif = ({ src, alt, isHovered, thumbSrc }) => {
  const [stillFrame, setStillFrame] = useState(null);
  const [canCapture, setCanCapture] = useState(true);
  const [showAnimatedFallback, setShowAnimatedFallback] = useState(false); // for CORS fallback: show GIF only after interaction
  const startedRef = useRef(false);
  const isGif = useMemo(() => (/\.gif($|\?)/i.test(src || "")), [src]);

  useEffect(() => {
    if (!src || startedRef.current) return;
    startedRef.current = true;

    // If a thumbnail is provided, prefer it as the still frame and skip canvas capture.
    if (thumbSrc) {
      setStillFrame(thumbSrc);
      setCanCapture(false); // we don't need to capture first frame when thumb exists
      // cache a lightweight payload to avoid other components re-capturing
      gifFrameCache.set(src, { frame: thumbSrc, canCapture: false });
      return;
    }

    if (!isGif) {
      setStillFrame(src);
      setCanCapture(true);
      return;
    }

    // Serve from cache if available
    if (gifFrameCache.has(src)) {
      const cached = gifFrameCache.get(src);
      setStillFrame(cached.frame);
      setCanCapture(cached.canCapture);
      return;
    }

    // If another component is already capturing, wait for it
    if (pendingCaptures.has(src)) {
      pendingCaptures.get(src).then((result) => {
        setStillFrame(result.frame);
        setCanCapture(result.canCapture);
      });
      return;
    }

    const capturePromise = new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.decoding = "async";
      img.loading = "lazy";
      img.src = src;
      img.onload = () => {
        let frameData = null;
        let capturable = true;
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth || img.width;
          canvas.height = img.naturalHeight || img.height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0);
          frameData = canvas.toDataURL("image/png");
        } catch (e) {
          capturable = false; // CORS taint
          frameData = null; // do not fall back to animated GIF
        }
        const payload = { frame: frameData, canCapture: capturable };
        gifFrameCache.set(src, payload);
        setStillFrame(frameData);
        setCanCapture(capturable);
        resolve(payload);
      };
      img.onerror = () => {
        const payload = { frame: null, canCapture: false };
        gifFrameCache.set(src, payload);
        setStillFrame(null);
        setCanCapture(false);
        resolve(payload);
      };
    }).finally(() => {
      pendingCaptures.delete(src);
    });

    pendingCaptures.set(src, capturePromise);
  }, [src]);

  // If capture failed, we can't extract a paused frame due to CORS.
  // In that case we show a non-animated placeholder UI and only load the GIF
  // when the user interacts (hover on desktop, tap on touch devices).
  if (!canCapture && !stillFrame) {
    // placeholder clickable area
    return (
      <div
        role="button"
        tabIndex={0}
        aria-label={alt}
        onMouseEnter={() => setShowAnimatedFallback(true)}
        onMouseLeave={() => setShowAnimatedFallback(false)}
        onClick={() => setShowAnimatedFallback((v) => !v)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ")
            setShowAnimatedFallback((v) => !v);
        }}
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0A031E",
          borderRadius: 10,
          position: "relative",
          overflow: "hidden",
        }}
      >
        {showAnimatedFallback ? (
          <ProductImage
            src={src}
            alt={alt}
            aria-label={alt}
            draggable={false}
            style={{ pointerEvents: "none" }}
          />
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 6,
              color: "#DFBD69",
            }}
          >
            {/* <div
              style={{
                width: "100%",
                height: "100%",
                borderRadius: 28,
                border: "2px solid rgba(223,189,105,0.18)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#0A031E",
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden
              >
                <path d="M8 5v14l11-7L8 5z" fill="#DFBD69" />
              </svg>
            </div>
            <div style={{ fontSize: 12, opacity: 0.9 }}>
              Tap / Hover to play
            </div> */}
          </div>
        )}
      </div>
    );
  }

  // Normal path:
  // - If we have a stillFrame (thumb or captured first frame), show it by default.
  // - Only swap to animated GIF source when the user hovers/taps.
  // - If stillFrame isn't ready yet, show a placeholder (non-animated) unless hovered.
  const displaySrc = stillFrame
    ? isHovered
      ? src
      : stillFrame
    : isHovered
    ? src
    : null;

  if (!displaySrc) {
    return (
      <div
        aria-label={alt}
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#0A031E",
          borderRadius: 10,
        }}
      />
    );
  }

  return (
    <ProductImage
      src={displaySrc}
      alt={alt}
      aria-label={alt}
      draggable={false}
      style={{ pointerEvents: "none" }}
    />
  );
};

const IconOverlay = styled.div`
  position: absolute;
  top: 8px;
  left: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  opacity: 1;
  z-index: 2;
`;
const NotificationModal = styled.div`
  position: fixed;
  bottom: 100px; /* Distance from the bottom of the screen */
  left: 50%; /* Start at the middle of the screen horizontally */
  transform: translateX(-50%); /* Shift the element to be centered */
  background-color: rgba(0, 0, 0, 0.75);
  color: white;
  padding: 10px;
  border-radius: 5px;
  width: 250px;
  text-align: center;
  opacity: ${(props) => (props.show ? 1 : 0)};
  transition: opacity 0.5s ease-in-out;
  z-index: 1000; /* Ensure the notification is above other content */
`;

const GreetingSection = styled.div`
  width: 100%;
  text-align: center;
  padding: 36px 24px 28px;
  box-sizing: border-box;
  background: transparent;

`;

const GreetingTitle = styled.h1`
  color: #deaf77;
  font-size: 2.5rem;
  font-weight: 800;
  font-family: 'PlayfairDisplay', serif; /* heading text */
  margin: 0 0 10px;
  letter-spacing: 0.5px;
  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

const GreetingText = styled.p`
  font-family: 'DMSans', sans-serif; /* body text */
  color: #fff2d2;
  font-size: 1.25rem;
  line-height: 1.6;
  margin: 0 auto;
  max-width: 760px;
  font-weight: 500;
`;

const SectionTitle = styled.h2`
  color: #deaf77;
  font-size: clamp(1.4rem, 3.2vw, 2.375rem);
  font-weight: 800;
  font-family: 'PlayfairDisplay', serif; /* heading text */
  text-align: center;
  margin: 0 0 20px;
  letter-spacing: 0.5px;
  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;

const ExpiryTabsRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  flex-wrap: wrap;
  margin-bottom: 44px;
  margin-top: 20px;
`;

const TabButton = styled.button`
  appearance: none;
  border: 1px solid ${(props) => (props.isActive ? '#deaf77' : 'rgba(201,168,75,0.4)')};
  background: ${(props) => (props.isActive ? '#deaf77' : '#0a031e')};
  color: ${(props) => (props.isActive ? '#0a031e' : '#f8f5fe')};
  border-radius: 10px;
  padding: 7px 20px;
  line-height: 16px;
  font-size: 1rem;
  font-family: 'PlayfairDisplay', sans-serif; /* body text */
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
  &:hover:not(:disabled) {
    background: ${(props) => (props.isActive ? '#deaf77' : 'rgba(223,189,105,0.12)')};
    outline: none;
  }
  min-width: 120px;
  width: fit-content;
  max-width: 152px;
  height: 40px;
`;

const PaginationRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-top: 28px;
  padding-bottom: 8px;
`;

const PageButton = styled.button`
  appearance: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid ${(props) => (props.isActive ? '#dfbd69' : 'rgba(201,168,75,0.4)')};
  background: ${(props) => (props.isActive ? '#dfbd69' : '#0a031e')};
  color: ${(props) => (props.isActive ? '#111' : '#deaf77')};
  font-size: 16px;
  font-weight: 900;
  font-family: 'DMSans', sans-serif;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, border-color 0.2s, color 0.2s;
  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
  &:hover:not(:disabled) {
    background: ${(props) => (props.isActive ? '#dfbd69' : 'rgba(223,189,105,0.12)')};
  }
`;

const ITEMS_PER_PAGE = 6;
// How long a purchase request is allowed to sit idle before we tell the user
// it looks slow, and the hard cutoff before we give up waiting entirely.
const TXN_SLOW_THRESHOLD_MS = 6000;
const TXN_TIMEOUT_MS = 20000;
const WHEEL_CATEGORY_ID = 'wheel';
// Query param that mirrors the open product overview modal, e.g. /shop?product=1042
const PRODUCT_URL_PARAM = 'product';
const ALLOWED_CATEGORY_DESCS = ['a-mu', 'your style', 'the living edit'];

const AmuHeroSection = styled.section`
  width: 100%;
  background: transparent;
  padding: 48px clamp(12px, 6vw, 118px) 0;
  box-sizing: border-box;
  @media (min-width: 1600px) {
    padding-inline: max(118px, calc((100% - 1176px) / 2));
  }
  @media (max-height: 760px) {
    padding-top: 24px;
  }
  @media (max-width: 768px) {
    padding: 28px 12px 0;
  }
`;

const AmuHeroInner = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  gap: 48px;
  @media (max-width: 768px) {
    flex-direction: column-reverse;
    gap: 20px;
  }
`;

const AmuHeroLeft = styled.div`
  flex: 0 1 auto;
  min-width: 0;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const AmuNavList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const AmuNavItem = styled.li`
  color: ${(props) => (props.isActive ? '#deaf77' : '#fff2d2')};
  font-size: 1rem;
  font-family: 'DMSans', sans-serif;
  font-weight: ${(props) => (props.isActive ? '700' : '500')};
  opacity: ${(props) => (props.isActive ? '1' : '0.8')};
  cursor: pointer;
  transition: opacity 0.2s, color 0.2s, font-weight 0.2s;
  border-left: 2px solid ${(props) => (props.isActive ? '#deaf77' : 'transparent')};
  padding-left: ${(props) => (props.isActive ? '8px' : '0')};
  &:hover {
    opacity: 1;
    color: #deaf77;
  }
`;

const amuInfoFade = `
  @keyframes amuInfoFadeIn {
    from { opacity: 0; transform: translateX(-20px); }
    to   { opacity: 1; transform: translateX(0); }
  }
`;

const AmuInfoBlock = styled.div`
  animation: amuInfoFadeIn 0.35s ease both;
  ${amuInfoFade}
`;

const AmuInfoTitle = styled.h2`
  color: #deaf77;
  font-size: 2rem;
  font-weight: 800;
  font-family: 'PlayfairDisplay', serif;
  margin: 0 0 12px;
  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

const AmuInfoText = styled.p`
  color: #fff2d2;
  font-size: 1rem;
  font-family: 'DMSans', sans-serif;
  line-height: 1.6;
  margin: 0;
  max-width: 440px;
`;

const AmuHeroRight = styled.div`
  flex-shrink: 0;
  margin-left: auto;
  @media (max-width: 768px) {
    margin-left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;

const AmuCardImage = styled.img`
  width: 300px;
  height: 398px;
  object-fit: contain;
  object-position: center;
  border-radius: 20px;
  border: 1px solid rgba(223, 189, 105, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.55);
  background: #0A031E;
  display: block;
  @media (max-width: 768px) {
    width: 180px;
    height: 220px;
  }
`;

const AmuWaveDivider = styled.div`
  width: 100%;
  text-align: center;
  margin: 36px 0 0;
  img {
    max-width: 660px;
    width: 100%;
    height: 44px;
    opacity: 0.85;
    filter: sepia(1) saturate(3) hue-rotate(5deg) brightness(1.1);
  }
`;

const AffiliateSection = styled.div`
  text-align: center;
  padding: 32px 24px 44px;
`;

const AffiliateSectionTitle = styled.h2`
  color: #deaf77;
  font-size: 2rem;
  font-weight: 800;
  font-family: 'PlayfairDisplay', serif;
  margin: 0 0 16px;
  @media (max-width: 768px) {
    font-size: 1.4rem;
  }
`;

const AffiliateSectionText = styled.p`
  color: #fff2d2;
  font-size: 1rem;
  font-family: 'DMSans', sans-serif;
  line-height: 1.7;
  margin: 0 auto;
  max-width: 560px;
`;

const AffiliateHighlight = styled.span`
  color: #deaf77;
  font-weight: 600;
`;

const txnSpinKeyframes = `
  @keyframes txnSpin {
    to { transform: rotate(360deg); }
  }
`;

const TxnSpinner = styled.div`
  margin: 0 auto 14px;
  width: 36px;
  height: 36px;
  border: 3px solid rgba(223, 189, 105, 0.25);
  border-top-color: #dfbd69;
  border-radius: 50%;
  animation: txnSpin 0.8s linear infinite;
  ${txnSpinKeyframes}
`;

function Shop() {
  const [activeTab, setActiveTab] = useState("digitalcharm");
  const [hoveredProduct, setHoveredProduct] = useState(null);
  const [activeGif, setActiveGif] = useState(null); // for tap-to-play on touch devices
  const [cart, setCart] = useState([]);
  const [maxPrice, setMaxPrice] = useState(10000); // Initialize max price for filtering
  const [toastMessage, setToastMessage] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedLifeAreas, setSelectedLifeAreas] = useState([]); // empty array = all
  const [searchQuery, setSearchQuery] = useState("");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [priceMinInput, setPriceMinInput] = useState("");
  const [priceMaxInput, setPriceMaxInput] = useState("");
  const [appliedPriceMin, setAppliedPriceMin] = useState(null);
  const [appliedPriceMax, setAppliedPriceMax] = useState(null);
  const [selectedExpiryBucket, setSelectedExpiryBucket] = useState("daily");
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const userID = localStorage.getItem("userID");
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const productParam = searchParams.get(PRODUCT_URL_PARAM);
  const [loading, setLoading] = useState(true);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [currentCoins, setCurrentCoins] = useState(0);
  const [insufficientGemsModal, setInsufficientGemsModal] = useState({ show: false, required: 0, current: 0 });
  const [stripeModalOpen, setStripeModalOpen] = useState(false);
  const [stripeAmount, setStripeAmount] = useState(0);
  const [stripeProduct, setStripeProduct] = useState(null);
  const { t, i18n } = useTranslation();
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem('language') || 'en'
  );

  const getDefaultLanguageId = (languageCode) => {
    const normalized = (languageCode || 'en').toString().toLowerCase();
    if (normalized === 'cn' || normalized === 'zh' || normalized === 'zh-cn') return '2226';
    if (normalized === 'id' || normalized === 'bahasa') return '2225';
    return '2224';
  };

  const effectiveLanguageId =
    localStorage.getItem('languageId') ||
    getDefaultLanguageId(localStorage.getItem('language'));

  const getExpiryLabel = (bucket) => {
    const map = {
      all: t('shop.all') || 'All',
      daily: t('shop.daily') || 'Daily',
      weekly: t('shop.weekly') || 'Weekly',
      monthly: t('shop.monthly') || 'Monthly',
      yearly: t('shop.yearly') || 'Yearly',
      other: 'Main',
    };
    return map[bucket] || bucket;
  };

  const translateShopLabel = (label) => {
    if (!label) return label;
    const normalizedKey = label
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '');
    return t(`shop.${normalizedKey}`, { defaultValue: label });
  };

  const [confirmGemModal, setConfirmGemModal] = useState({ show: false, product: null });
  // Surfaces the outcome of a purchase request even when the network hangs or is
  // slow: "processing" -> (optionally) "slow" -> "success" | "error" | "unknown".
  // "unknown" is used when a request times out and we genuinely can't tell
  // whether it went through, so we don't falsely claim success or failure.
  const [txnStatusModal, setTxnStatusModal] = useState({ show: false, phase: "processing", message: "" });
  const [confirmPurchaseModal, setConfirmPurchaseModal] = useState({ show: false, product: null });
  const [confirmAddToCartModal, setConfirmAddToCartModal] = useState({ show: false, product: null });
  const [gemPurchaseLoading, setGemPurchaseLoading] = useState(false); // Add this line
  const [guardianModal, setGuardianModal] = useState({ show: false, pendingProduct: null });
  const userAgeRef = useRef(undefined); // undefined = not yet fetched, null = fetched / no data

  const fetchUserAge = async () => {
    if (userAgeRef.current !== undefined) return userAgeRef.current;
    try {
      const res = await fetch("https://xianhefairy.com/LotusFairy_API/api/User/GetProfile", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          UserName: localStorage.getItem("username") || "",
          ID: parseInt(userID || "0", 10),
          LangId: parseInt(localStorage.getItem("languageId") || "2224", 10) || 2224,
          UserToken: "",
          Token: { AccessToken: "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp" },
        }),
      });
      if (!res.ok) { userAgeRef.current = null; return null; }
      const data = await res.json();
      const age = data?.Profiles?.[0]?.Age ?? null;
      userAgeRef.current = age;
      return age;
    } catch {
      userAgeRef.current = null;
      return null;
    }
  };
  const [showSignInModal, setShowSignInModal] = useState(false); // Add this state
  const [showBuyOptions, setShowBuyOptions] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedProduct, setSelectedProduct] = useState(null); // add this
  const [activeNavItem, setActiveNavItem] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const [products, setProducts] = useState([]);
  const [wheelDraws, setWheelDraws] = useState([]);

  const splitLifeAreas = (raw) => {
    if (Array.isArray(raw)) {
      return raw.reduce((acc, entry) => {
        const value =
          typeof entry === 'string'
            ? entry
            : (entry && (entry.LifeAreas || entry.LIFE_AREAS || entry.lifeAreas)) || '';
        return acc.concat(splitLifeAreas(value));
      }, []);
    }
    if (!raw || typeof raw !== 'string') return [];
    return raw
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
  };

  // Life areas come from the LIST_LIFE_AREAS array ([{ LifeAreas: 'Health' }, ...]).
  const extractLifeAreas = (item) => {
    const collected = splitLifeAreas(item && item.LIST_LIFE_AREAS);
    const seen = new Set();
    const unique = [];
    for (const area of collected) {
      const key = area.toLowerCase();
      if (seen.has(key)) continue;
      seen.add(key);
      unique.push(area);
    }
    return unique;
  };

  // A product matches if it carries any selected life area (OR).
  // No selection means no life-area filtering at all.
  const matchesLifeAreas = (productAreas, selected) =>
    selected.length === 0 || selected.some((area) => (productAreas || []).includes(area));

  const expiryBucketFromDays = (daysExpire, descEng) => {
    const days = Number(daysExpire);
    if (Number.isFinite(days)) {
      if (days === 1) return 'daily';
      if (days === 7) return 'weekly';
      if (days >= 28 && days <= 31) return 'monthly';
      if (days >= 360 && days <= 366) return 'yearly';
      if (days > 0) return 'other';
    }
    // fallback to DESC_ENG text
    if (descEng && typeof descEng === 'string') {
      const lower = descEng.toLowerCase();
      if (lower.includes('daily')) return 'daily';
      if (lower.includes('weekly')) return 'weekly';
      if (lower.includes('monthly')) return 'monthly';
      if (lower.includes('yearly')) return 'yearly';
    }
    return 'other';
  };

  // Helper to extract numeric prefix and number from CODE (e.g., "DC001-2" => {prefixNum: 1, num: 2})
  function parseCode(code) {
    if (!code || typeof code !== "string") return { prefixNum: 99999, num: 99999 };
    // Match "DC001-2" or "DC2026"
    const match = code.match(/^([A-Za-z]+)(\d+)(?:-(\d+))?$/);
    if (!match) return { prefixNum: 99999, num: 99999 };
    return {
      prefixNum: parseInt(match[2], 10), // e.g., 1 or 2026
      num: match[3] ? parseInt(match[3], 10) : 0, // e.g., 2 or 0 if no dash
    };
  }

  function codeSort(a, b) {
    const ac = parseCode(a?.raw?.CODE);
    const bc = parseCode(b?.raw?.CODE);
    if (ac.prefixNum !== bc.prefixNum) return ac.prefixNum - bc.prefixNum;
    return ac.num - bc.num;
  }

  const categories = useMemo(() => {
    const map = new Map();
    for (const p of products) {
      const id = p.categoryId || '0';
      const desc = p.categoryDesc || 'Uncategorized';
      if (!ALLOWED_CATEGORY_DESCS.includes(desc.toLowerCase().trim())) continue;
      if (!map.has(id)) map.set(id, { id, desc, count: 0 });
      map.get(id).count += 1;
    }
    const sorted = Array.from(map.values()).sort((a, b) => {
      const na = Number(a.id);
      const nb = Number(b.id);
      if (Number.isFinite(na) && Number.isFinite(nb)) return na - nb;
      return String(a.desc).localeCompare(String(b.desc));
    });
    // Only show the wheel category after product categories have been loaded
    if (map.size > 0) {
      sorted.push({ id: WHEEL_CATEGORY_ID, desc: 'The Wheel', count: wheelDraws.length });
    }
    return sorted;
  }, [products, wheelDraws]);

  const amuNavItems = useMemo(() => categories.map((c) => c.id), [categories]);

  // Map API category descriptions to translation keys in shop.hero.nav
  const getCategoryNavKey = (desc) => {
    if (!desc) return null;
    const lower = desc.toLowerCase().trim();
    if (lower === 'a-mu' || lower === 'a-mu +') return 'amuplus';
    if (lower === 'the wheel' || lower === 'thewheel') return 'thewheel';
    if (lower === 'your style') return 'yourstyle';
    if (lower === 'the living edit') return 'thelivingedit';
    return null;
  };

  const amuNavContent = useMemo(() => {
    return categories.reduce((acc, c) => {
      const navKey = getCategoryNavKey(c.desc);
      if (navKey) {
        acc[c.id] = {
          navLabel: t(`shop.hero.nav.${navKey}.navLabel`, { defaultValue: c.desc }),
          title: t(`shop.hero.nav.${navKey}.title`, { defaultValue: c.desc }),
          text: t(`shop.hero.nav.${navKey}.text`, { defaultValue: '' }),
          image: NAV_IMAGES[navKey] || amulet,
        };
      } else {
        acc[c.id] = {
          navLabel: c.desc,
          title: c.desc,
          text: '',
          image: amulet,
        };
      }
      return acc;
    }, {});
  }, [categories, t]);

  const selectedCategoryDesc = useMemo(() => {
    return categories.find((c) => c.id === selectedCategoryId)?.desc || '';
  }, [categories, selectedCategoryId]);

  const selectedCategoryDescTranslated = useMemo(() => {
    return translateShopLabel(selectedCategoryDesc);
  }, [selectedCategoryDesc, t]);

  useEffect(() => {
    if (categories.length > 0 && (!selectedCategoryId || !activeNavItem)) {
      // If navigated from FortuneStick with tab='wheel', pre-select The Wheel
      if (location.state?.tab === 'wheel') {
        const wheelCat = categories.find((c) => c.id === WHEEL_CATEGORY_ID);
        if (wheelCat) {
          setSelectedCategoryId(WHEEL_CATEGORY_ID);
          setActiveNavItem(WHEEL_CATEGORY_ID);
          setActiveTab('thewheel');
          return;
        }
      }
      // Prefer the A-Mu category as the initial selection when available
      let first = categories[0];
      const amuItem = categories.find((c) => /a-?mu/i.test(String(c.desc || '')));
      if (amuItem) first = amuItem;
      if (!selectedCategoryId) setSelectedCategoryId(first.id);
      if (!activeNavItem) setActiveNavItem(first.id);
      setActiveTab((first.desc || '').toLowerCase().replace(/\s+/g, ''));
    }
  }, [categories, selectedCategoryId, activeNavItem]);

  const availableLifeAreas = useMemo(() => {
    const set = new Set();
    for (const p of products) {
      if (selectedCategoryId && p.categoryId !== selectedCategoryId) continue;
      for (const area of p.lifeAreas || []) set.add(area);
    }
    return Array.from(set.values()).sort((a, b) => a.localeCompare(b));
  }, [products, selectedCategoryId]);

  const availableExpiryBuckets = useMemo(() => {
    const set = new Set();
    for (const p of products) {
      if (selectedCategoryId && p.categoryId !== selectedCategoryId) continue;
      if (!matchesLifeAreas(p.lifeAreas, selectedLifeAreas)) continue;
      set.add(p.expiryBucket || 'other');
    }
    const order = ['daily', 'weekly', 'monthly', 'yearly', 'other'];
    return Array.from(set.values()).sort((a, b) => order.indexOf(a) - order.indexOf(b));
  }, [products, selectedCategoryId, selectedLifeAreas]);

  const toggleLifeArea = (area) => {
    setSelectedLifeAreas((prev) =>
      prev.includes(area) ? prev.filter((a) => a !== area) : [...prev, area]
    );
  };

  const applyPriceRange = () => {
    const minTrim = priceMinInput.trim();
    const maxTrim = priceMaxInput.trim();
    const min = minTrim === '' ? null : Number(minTrim);
    const max = maxTrim === '' ? null : Number(maxTrim);
    setAppliedPriceMin(min !== null && Number.isFinite(min) ? min : null);
    setAppliedPriceMax(max !== null && Number.isFinite(max) ? max : null);
  };

  const clearAllFilters = () => {
    setSearchQuery('');
    setSelectedLifeAreas([]);
    setPriceMinInput('');
    setPriceMaxInput('');
    setAppliedPriceMin(null);
    setAppliedPriceMax(null);
  };

  const activeFilterCount =
    (searchQuery.trim() ? 1 : 0) +
    selectedLifeAreas.length +
    (appliedPriceMin != null ? 1 : 0) +
    (appliedPriceMax != null ? 1 : 0);

  const filteredProducts = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    return products
      .filter((p) => (selectedCategoryId ? p.categoryId === selectedCategoryId : true))
      .filter((p) => matchesLifeAreas(p.lifeAreas, selectedLifeAreas))
      .filter((p) => (selectedExpiryBucket === 'all' ? true : (p.expiryBucket || 'other') === selectedExpiryBucket))
      .filter((p) => (appliedPriceMin == null ? true : p.price >= appliedPriceMin))
      .filter((p) => (appliedPriceMax == null ? true : p.price <= appliedPriceMax))
      .filter((p) => (q === '' ? true : (p.name || '').toLowerCase().includes(q) || (p.desc_oth || '').toLowerCase().includes(q) || (p.details || '').toLowerCase().includes(q)))
      .sort(codeSort);
  }, [products, selectedCategoryId, selectedLifeAreas, selectedExpiryBucket, appliedPriceMin, appliedPriceMax, searchQuery]);

  const totalPages = Math.max(1, Math.ceil(filteredProducts.length / ITEMS_PER_PAGE));

  const paginatedProducts = useMemo(() => {
    const start = (currentPage - 1) * ITEMS_PER_PAGE;
    return filteredProducts.slice(start, start + ITEMS_PER_PAGE);
  }, [filteredProducts, currentPage]);

  const wheelDisplayItems = useMemo(() => wheelDraws.map((draw) => ({
    id: draw.Id,
    name: draw.Description,
    desc_oth: draw.Description,
    price: draw.Cash,
    charm: draw.Gem,
    details: `${draw.Qty} Draws`,
    image: draw.ImageUrl || '',
    hoverImage: draw.ImageUrl || '',
    ImageUrl: draw.ImageUrl || '',
    thumb: draw.ImageUrl || '',
    categoryId: WHEEL_CATEGORY_ID,
    categoryDesc: 'The Wheel',
    expiryBucket: 'other',
    lifeAreas: [],
    raw: draw,
  })), [wheelDraws]);

    const filteredWheelItems = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    return wheelDisplayItems
      .filter((p) => (appliedPriceMin == null ? true : p.price >= appliedPriceMin))
      .filter((p) => (appliedPriceMax == null ? true : p.price <= appliedPriceMax))
      .filter((p) => (q === '' ? true : (p.name || '').toLowerCase().includes(q) || (p.desc_oth || '').toLowerCase().includes(q)));
  }, [wheelDisplayItems, appliedPriceMin, appliedPriceMax, searchQuery]);


  // ── Product overview modal ⇄ URL (?product=...) ──────────────────────────
  // The URL carries a slug of the product's display name (DESC_OTH) so links are
  // readable. Letters/digits of any script are kept, so a title like
  // "Shining Star 星星闪耀" slugs to "shining-star-星星闪耀" rather than losing the
  // non-Latin half.
  const slugifyName = (value) =>
    String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^\p{L}\p{N}]+/gu, '-')
      .replace(/^-+|-+$/g, '');

  // Wheel draws and products are separate lists whose slugs/IDs can overlap, so
  // wheel items get a "wheel-" prefix in the URL.
  const productUrlKey = (product) => {
    if (!product) return '';
    const slug =
      slugifyName(product.desc_oth) ||
      slugifyName(product.name) ||
      String(product.id ?? '');
    return product.categoryId === WHEEL_CATEGORY_ID ? `wheel-${slug}` : slug;
  };

  const findProductByUrlKey = (key) => {
    if (!key) return null;
    const isWheel = key.startsWith('wheel-');
    const bare = isWheel ? key.slice('wheel-'.length) : key;
    const list = isWheel ? wheelDisplayItems : products;
    return (
      list.find((p) => slugifyName(p.desc_oth) === bare) ||
      // Fallbacks so links survive a language switch or predate the slug scheme.
      list.find((p) => slugifyName(p.name) === bare) ||
      list.find((p) => String(p.id) === bare) ||
      null
    );
  };

  const setProductParam = (key, { replace = false } = {}) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (key) next.set(PRODUCT_URL_PARAM, key);
        else next.delete(PRODUCT_URL_PARAM);
        return next;
      },
      { replace }
    );
  };

  // Opening pushes a history entry so the browser back button closes the modal;
  // closing replaces it so back doesn't immediately re-open it.
  const openProduct = (product) => setProductParam(productUrlKey(product));
  const closeProduct = () => setProductParam(null, { replace: true });

  // The URL is the source of truth: this drives the modal for clicks, refreshes,
  // shared links and back/forward navigation alike. Deliberately not gated on
  // login — a shared link must open for signed-out visitors; the purchase
  // actions inside the modal do their own sign-in check.
  useEffect(() => {
    if (!productParam) {
      if (selectedProduct) setSelectedProduct(null);
      return;
    }

    // Only judge the key against the list it actually belongs to, and only once
    // that list has loaded. products and wheelDraws are fetched independently, so
    // treating "either one arrived" as ready would drop a valid product link
    // whenever the draws request wins the race.
    const listReady = productParam.startsWith('wheel-')
      ? wheelDisplayItems.length > 0
      : products.length > 0;
    if (!listReady) return; // retry when the data lands

    const match = findProductByUrlKey(productParam);
    if (!match) {
      setProductParam(null, { replace: true }); // genuinely stale/unknown link
      return;
    }

    const canonicalKey = productUrlKey(match);
    if (canonicalKey && canonicalKey !== productParam) {
      setProductParam(canonicalKey, { replace: true }); // e.g. rewrite an ID link to its slug
    }

    if (productUrlKey(selectedProduct) !== canonicalKey) {
      setSelectedCategoryId(match.categoryId);
      setActiveNavItem(match.categoryId);
      setSelectedProduct(match);
    }
  }, [productParam, products, wheelDisplayItems]);

  // When category changes, reset life area and pick the first available expiry bucket
  useEffect(() => {
    setSelectedLifeAreas([]);
    const buckets = (() => {
      const set = new Set();
      const items = selectedCategoryId === WHEEL_CATEGORY_ID
        ? wheelDraws.map((d) => ({ expiryBucket: 'other', lifeAreas: [] }))
        : products.filter((p) => !selectedCategoryId || p.categoryId === selectedCategoryId);
      for (const p of items) set.add(p.expiryBucket || 'other');
      const order = ['daily', 'weekly', 'monthly', 'yearly', 'other'];
      return Array.from(set.values()).sort((a, b) => order.indexOf(a) - order.indexOf(b));
    })();
    setSelectedExpiryBucket(buckets.length > 0 ? buckets[0] : 'daily');
    setCurrentPage(1);
  }, [selectedCategoryId]);

  // Reset to page 1 whenever sub-filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedLifeAreas, selectedExpiryBucket, appliedPriceMin, appliedPriceMax, searchQuery]);

  const getImageSrc = (product) => {
    // If ImageUrl is provided by the API, prefer it; otherwise fall back to existing image field
    return product.ImageUrl || product.image || product.FILENAME || "";
  };

  const getHoverImageSrc = (product) => {
    return product.ImageUrl || product.hoverImage || product.FILENAME || "";
  };

  const showToast = (message) => {
    setToastMessage(message);
    setTimeout(() => {
      setToastMessage("");
    }, 3000); // hides after 3 seconds
  };
  useEffect(() => {
    fetch(`https://xianhefairy.com/LotusFairy_API/api/member/getProduct?LangId=${effectiveLanguageId}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((fetchedData) => {
        const allProducts = fetchedData.map((item) => {
          const categoryId = item.CATEGORY != null ? String(item.CATEGORY) : '0';
          const categoryDesc = item.CATEGORY_DESC || 'Uncategorized';
          const daysExpire =
            typeof item.DAYS_EXPIRE === 'number'
              ? item.DAYS_EXPIRE
              : item.DAYS_EXPIRE
              ? Number(item.DAYS_EXPIRE)
              : 0;
          const expiryBucket = expiryBucketFromDays(daysExpire, item.DESC_ENG);
          const lifeAreas = extractLifeAreas(item);

          // Prefer TUMB_URL or ThumbFile as the thumbnail (default static preview),
          // and use ImageUrl (often a GIF) as the hover/animated preview.
          const thumb = item.TUMB_URL || item.ThumbFile || item.Thumb || "";
          return {
            id: item.ID,
            name: item.DESC_ENG || item.DISPLAY_NAME || item.FILENAME,
            desc_oth: item.DESC_OTH || "",
            price:
              typeof item.CASH_AMT === "number"
                ? item.CASH_AMT
                : item.CASH_AMT
                ? Number(item.CASH_AMT)
                : 0,
            charm: item.OTHER_AMT || 0,
            details: item.REMARK || item.DESCRIPTION || "",
            // image will be the thumbnail if provided, otherwise fallback to ImageUrl or other fields
            image: thumb || item.ImageUrl || getImageSrc(item),
            // hoverImage is the animated source (ImageUrl) if available
            hoverImage: item.ImageUrl || getHoverImageSrc(item),
            // preserve original ImageUrl for downstream usage
            ImageUrl: item.ImageUrl || "",
            thumb,
            categoryId,
            categoryDesc,
            expiryBucket,
            daysExpire,
            lifeAreas,
            raw: item, // keep raw API item for debugging if needed
          };
        });

        setProducts(allProducts);
        //setFilteredProducts(allProducts); // Initially show all products
        //fetchDigitalCharmData();
      })
      .catch((error) => console.error("Error fetching product data:", error));
  }, []);

  useEffect(() => {
    fetch('https://xianhefairy.com/LotusFairy_API/api/draws/GetListDraws')
      .then((res) => { if (!res.ok) throw new Error('Network error'); return res.json(); })
      .then((data) => { if (Array.isArray(data)) setWheelDraws(data); })
      .catch((err) => console.error('Error fetching wheel draws:', err));
  }, []);

  // Detect touch device once (for tap-to-play logic)
  useEffect(() => {
    const touch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    setIsTouchDevice(touch);
  }, []);

  // Note: we intentionally do NOT preload GIFs so they only animate when hovered/tapped.

  const [userUID, setUserUID] = useState("");
  const [serverCart, setServerCart] = useState([]);

  // Check login status on component mount
  useEffect(() => {
    const userId = localStorage.getItem("userID");
    const userName = localStorage.getItem("username");
    setIsLoggedIn(Boolean(userId && userName));
  }, []);

  // Open the exact product's overview modal when navigated here from a chat recommendation
  const openedProductFromStateRef = useRef(false);
  useEffect(() => {
    const openProductId = location.state?.openProductId;
    if (openProductId == null || openedProductFromStateRef.current || products.length === 0) return;
    const match = products.find((p) => String(p.id) === String(openProductId));
    if (!match) return;
    openedProductFromStateRef.current = true;
    // Hand off to the URL; the ?product= sync effect opens the modal.
    setProductParam(productUrlKey(match), { replace: true });
  }, [products, location.state]);

  // Fetch cart on component load
  useEffect(() => {
    fetchCart();
  }, []);

  const parseCartField = (raw) => {
    if (!raw) return [];
    try {
      const data = JSON.parse(raw);
      return Array.isArray(data) ? data : [];
    } catch {
      console.warn("CART field was not valid JSON – defaulting to []");
      return [];
    }
  };

  // const fetchCart = async () => {
  //   try {
  //     const response = await fetch(
  //       `https://xianhefairy.com/LotusFairy_API/api/booking/getCart?ID=${userID}`
  //     );
  //     const data = await response.json();

  //     if (!Array.isArray(data) || data.length === 0)
  //       return { UID: "", cart: [] };

  //     const cartRecord = data[0];
  //     const cart = JSON.parse(cartRecord.CART || "[]");

  //     return {
  //       UID: cartRecord.UID,
  //       cart,
  //       createdBy: cartRecord.CREATED_BY,
  //       updatedBy: cartRecord.UPDATE_BY,
  //     };
  //   } catch (error) {
  //     console.error("Failed to fetch cart:", error);
  //     return { UID: "", cart: [] };
  //   }
  // };

  const fetchCart = async () => {
  try {
    const cartRes = await fetch(
      `https://xianhefairy.com/LotusFairy_API/api/Usercart/GetUserCart?CustId=${userID}`
    );
    if (!cartRes.ok) throw new Error("Failed to fetch cart from server");

    const cartApiResult = await cartRes.json();
    if (!Array.isArray(cartApiResult) || cartApiResult.length === 0) {
      setCart([]);
      setLoading(false);
      return { cart: [] }; // <-- return empty cart object
    }

    const mappedCart = cartApiResult.map((item) => ({
      Uid: item.Uid,
      CustId: item.CustId,
      ProdId: item.ProdId,
      ProdDesc: item.ProdDesc,
      Remark: item.ProdRemarks,
      Qty: item.Qty,
      CardAmount: item.TotalAmount,
      GemAmount: item.GemTotal,
      ProdGif: item.ProdGif,
      ProdThumbnail: item.ProdThumbnail,
    }));

    setCart(mappedCart);
    return { cart: mappedCart }; // <-- return cart object
  } catch (error) {
    console.error("Error fetching cart:", error);
    setCart([]);
    return { cart: [] }; // <-- return empty cart object on error
  } finally {
    setLoading(false);
  }
};
  // const fetchCart = async () => {
  //   try {
  //     const res = await fetch(
  //       `https://xianhefairy.com/LotusFairy_API/api/booking/getCart?ID=${userID}`
  //     );
  //     const data = await res.json();

  //     if (!Array.isArray(data) || data.length === 0)
  //       return { UID: "", cart: [] };

  //     const rec = data[0];
  //     return {
  //       UID: rec.UID,
  //       cart: parseCartField(rec.CART),
  //       createdBy: rec.CREATED_BY,
  //       updatedBy: rec.UPDATE_BY,
  //     };
  //   } catch (err) {
  //     console.error("Failed to fetch cart:", err);
  //     return { UID: "", cart: [] };
  //   }
  // };

  // const fetchDigitalCharmData = async () => {
  //   try {
  //     const response = await fetch(
  //       `https://xianhefairy.com/LotusFairy_API/api/booking/getDigitalCharm?ID=${userID}`
  //     );
  //     if (!response.ok) {
  //       throw new Error(`HTTP error! Status: ${response.status}`);
  //     }
  //     const data = await response.json();
  //     console.log("success getting the digital UID", data[0].UID);
  //     setUserUID(data[0].UID);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  const addToCart = async (product) => {
    if (!isLoggedIn) {
      setShowSignInModal(true); // Show modal instead of alert
      // navigate("/login");
      return;
    }

    if (userID) {
      try {
        // For wheel products, match to the corresponding getProduct API item
        let prodId = product.id;
        let prodDesc = product.desc_oth || product.name || "";
        if (product.categoryId === WHEEL_CATEGORY_ID) {
          const matched = products.find(
            (p) => p.desc_oth === product.desc_oth || p.name === product.name
          );
          if (matched) {
            prodId = matched.id;
            prodDesc = matched.desc_oth || matched.name || "";
          }
        }

        const payload = {
          Uid: "",
          CustId: Number(userID),
          Qty: 1,
          ProdId: prodId,
          ProdDesc: prodDesc,
        };

        console.log("Add to cart payload:", payload);

        const response = await fetch(
          `https://xianhefairy.com/LotusFairy_API/api/Usercart/UserCartUpdate`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );

        const result = await response.json();
        console.log("API response:", result);

        if (result.successful) {
          showToast(result.save_msg || t('shop.added'));
          
          // ✅ Dispatch event for same tab
          window.dispatchEvent(new CustomEvent('cartUpdated'));
          
          // ✅ Update localStorage to trigger event in other tabs
          localStorage.setItem('cartUpdatedAt', Date.now().toString());
        } else {
          showToast(result.return_err || "Failed to add to cart.");
          console.error("Add to cart failed:", result);
        }
      } catch (error) {
        console.error("Error adding to cart:", error);
        showToast("Error adding to cart.");
      }
    } else {
      navigate("/main");
      alert("You need to log in before placing an order.");
    }
  };

  // const addToCart = async (product) => {
  //   if (userID) {
  //     const token = "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp";

  //     try {
  //       // Step 1: Get current cart
  //       const { UID, cart, createdBy, updatedBy } = await fetchCart();

  //       // Step 2: Update or insert product in cart
  //       const updatedCart = [...cart];
  //       const index = updatedCart.findIndex(
  //         (item) => item.Product_ID === product.id
  //       );

  //       if (index !== -1) {
  //         updatedCart[index].Quantity += product.quantity || 1;
  //       } else {
  //         updatedCart.push({
  //           Product_ID: product.id,
  //           Quantity: product.quantity || 1,
  //         });
  //       }

  //       // Step 3: Send updated cart to API
  //       const requestBody = {
  //         UID,
  //         CustomerID: userID,
  //         CartData: updatedCart,
  //         CreatedBy: createdBy || userID,
  //         UpdatedBy: updatedBy || userID,
  //         Status: 0,
  //       };

  //       const response = await fetch(
  //         `https://xianhefairy.com/LotusFairy_API/api/booking/AddCart?token=${token}`,
  //         {
  //           method: "POST",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify(requestBody),
  //         }
  //       );

  //       const result = await response.json();
  //       console.log("Updated cart body sent:", requestBody);
  //       console.log("API response:", result);

  //       if (!response.ok) {
  //         console.error("Failed to update cart:", result);
  //       } else {
  //         showToast(
  //           `${
  //             product.desc_oth || product.name || product.FILENAME
  //           } added to cart.`
  //         );
          
  //         // ✅ Dispatch custom event to notify header
  //         window.dispatchEvent(new CustomEvent('cartUpdated'));
  //       }
  //     } catch (error) {
  //       console.error("Error adding to cart:", error);
  //     }
  //   } else {
  //     navigate("/main");
  //     alert("You need to log in before placing an order.");
  //   }
  // };

  const handleExpiryFilter = (bucket) => {
    setSelectedExpiryBucket(bucket);
  };

  const fetchTotalCoins = async () => {
    try {
      const response = await fetch(
        `https://xianhefairy.com/LotusFairy_API/api/booking/getTotal?ID=${userID}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      const coins = data[0].COINS;
      localStorage.setItem("coins", coins);
      setCurrentCoins(coins);
      console.log("Fetched total coins:", coins);
      
      return coins; // ← Return the coins value
    } catch (error) {
      console.error("Error fetching data:", error);
      return 0;
    }
  };

  // Runs `fn` (an async purchase request) behind the transaction status modal.
  // If `fn` hasn't settled within TXN_SLOW_THRESHOLD_MS, the modal switches to a
  // "this looks slow" message without cancelling the request. If `fn` itself
  // throws a TimeoutError (see fetchWithTimeout), we can't know whether the
  // server actually processed the purchase, so we surface that honestly as
  // "unknown" instead of claiming success or failure.
  const runTransaction = async (fn, { successMessage, errorMessage, unknownMessage } = {}) => {
    let settled = false;
    setTxnStatusModal({
      show: true,
      phase: "processing",
      message: t("shop.txnProcessing") || "Processing your transaction...",
    });
    const slowTimer = setTimeout(() => {
      if (settled) return;
      setTxnStatusModal((prev) =>
        prev.show && prev.phase === "processing"
          ? {
              ...prev,
              phase: "slow",
              message:
                t("shop.txnSlow") ||
                "This is taking longer than usual — your connection may be slow. Please keep this window open.",
            }
          : prev
      );
    }, TXN_SLOW_THRESHOLD_MS);

    try {
      const result = await fn();
      settled = true;
      clearTimeout(slowTimer);
      setTxnStatusModal({
        show: true,
        phase: "success",
        message: successMessage || t("shop.txnSuccess") || "🎉 Transaction successful!",
      });
      return result;
    } catch (err) {
      settled = true;
      clearTimeout(slowTimer);
      const isTimeout = err?.name === "TimeoutError";
      setTxnStatusModal({
        show: true,
        phase: isTimeout ? "unknown" : "error",
        message: isTimeout
          ? unknownMessage ||
            t("shop.txnUnknown") ||
            "We couldn't confirm your transaction due to a connection issue. Please check your balance or purchase history before trying again."
          : errorMessage || t("shop.txnError") || "❌ Transaction failed. Please try again.",
      });
      throw err;
    }
  };

  const handleConfirmPurchase = async ({ paymentMethod, cartItems }) => {
    console.log("[handleConfirmPurchase] called with:", { paymentMethod, cartItems });

    const coins = await fetchTotalCoins();
    console.log("[handleConfirmPurchase] latest coins:", coins);

    if (paymentMethod === "coins") {
      const requiredGems = cartItems.reduce(
        (sum, item) => sum + (item.Amount || 0),
        0
      );
      console.log("[handleConfirmPurchase] requiredGems:", requiredGems);

      if (coins < requiredGems) {
        console.warn("[handleConfirmPurchase] insufficient gems", { coins, requiredGems });
        setConfirmLoading(false);
        setInsufficientGemsModal({ show: true, required: requiredGems, current: coins });
        return;
      }
    }

    const isStripe = paymentMethod === "stripe";

    try {
      await runTransaction(
        async () => {
          console.log("[handleConfirmPurchase] about to submit purchase fetch");
          const items = cartItems.map((item) => ({
            CustomerId: Number(userID),
            pid: item.ID,
            Quantity: item.quantity || 1,
            Amount: item.Amount,
          }));

          const payload = {
            prefix: "PCH",
            PAY_MODE: isStripe ? 1 : 0,
            items,
          };

          console.log("[handleConfirmPurchase] Submitting payload:", payload);

          const res = await fetchWithTimeout(
            "https://xianhefairy.com/LotusFairy_API/api/member/PostPurchaseCoin",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payload),
            },
            TXN_TIMEOUT_MS
          );

          const resBody = await res.json().catch(() => null);
          console.log("[handleConfirmPurchase] API status:", res.status, "body:", resBody);

          if (!res.ok) {
            throw new Error("Failed to submit purchase");
          }
          return resBody;
        },
        {
          successMessage: isStripe
            ? t("shop.stripeSuccess") || "🎉 Stripe payment successful!"
            : t("shop.gemSuccess") || "🎉 Amulet purchase successful!",
          // A failure here after a Stripe charge means the card was already
          // charged but our order couldn't be recorded, so the messaging needs
          // to say that explicitly rather than implying nothing happened.
          errorMessage: isStripe
            ? t("shop.stripeOrderError") ||
              "⚠️ Payment received, but we couldn't confirm your order. Please contact support."
            : t("shop.gemError") || "❌ Purchase failed. Please try again.",
          unknownMessage: isStripe
            ? t("shop.stripeOrderUnknown") ||
              "⚠️ Payment received, but confirming your order is taking too long due to a connection issue. Please check your amulets in a moment, or contact support if they don't appear."
            : t("shop.gemUnknown") ||
              "We couldn't confirm your purchase due to a connection issue. Please check your gem balance before trying again.",
        }
      );

      setCart([]);
      localStorage.removeItem("cart");
      window.dispatchEvent(new CustomEvent("cartUpdated"));
      window.dispatchEvent(new CustomEvent("gemsUpdated"));
    } catch (err) {
      console.error("[handleConfirmPurchase] Purchase failed:", err);
      throw err; // so caller knows it failed
    } finally {
      setConfirmLoading(false);
      fetchTotalCoins(); // refresh the displayed balance regardless of outcome
    }
  };


  // const autoBuy = async (product) => {
  //   if (!isLoggedIn) {
  //     alert("Please sign in to purchase.");
  //     //navigate("/login");
  //     return;
  //   }
  //   const age = await fetchUserAge();
  //   if (age !== null && age < 18) {
  //     setGuardianModal({ show: true, pendingProduct: product });
  //     return;
  //   }
  //   // For all card purchases (including wheel/draw items), open the Stripe modal first.
  //   // onPaymentSuccess will call StickPurchase for wheel items.
  //   console.log("[autoBuy] Initiating Stripe modal for product:", product);
  //   setStripeAmount(product.price);
  //   setStripeProduct(product);
  //   setStripeModalOpen(true);
  // };

  // const autoBuyWithGems = async (product) => {
  //   if (!isLoggedIn) {
  //     setShowSignInModal(true);
  //     //navigate("/login");
  //     return;
  //   }
  //   if (gemPurchaseLoading) return; // Prevent multiple clicks
  //   setGemPurchaseLoading(true);
  //
  //   try {
  //     console.log("[autoBuyWithGems] Initiating Gems auto-buy for product:", product);
  //     const userCoins = await fetchTotalCoins();
  //     console.log("[autoBuyWithGems] User coins fetched:", userCoins);
  //
  //     if (userCoins < product.charm) {
  //       console.warn(`[autoBuyWithGems] Insufficient Gems! Needed: ${product.charm}, Available: ${userCoins}`);
  //       alert(`Insufficient Gems! You need ${product.charm} gems but only have ${userCoins}.`);
  //       setGemPurchaseLoading(false); // ← Add this line to reset loading state
  //       return;
  //     }
  //
  //     // Draw (wheel) items use StickPurchase; pay_mode=0 for gems
  //     if (product.categoryId === WHEEL_CATEGORY_ID) {
  //       console.log("[autoBuyWithGems] Initiating StickPurchase (gems) for draw:", product);
  //       const res = await fetch(
  //         `https://xianhefairy.com/LotusFairy_API/api/draws/StickPurchase?CustId=${userID}&pay_mode=0`,
  //         {
  //           method: "POST",
  //           headers: { "Content-Type": "application/json" },
  //           body: JSON.stringify([{ Id: product.id, Qty: 1 }]),
  //         }
  //       );
  //       const body = await res.json().catch(() => null);
  //       console.log("[autoBuyWithGems] StickPurchase response:", res.status, body);
  //       if (!res.ok) throw new Error("StickPurchase failed");
  //       showToast("🎉 Draw purchased with Gems successfully!");
  //       window.dispatchEvent(new CustomEvent("gemsUpdated"));
  //       return;
  //     }
  //
  //     console.log("[autoBuyWithGems] Calling handleConfirmPurchase...");
  //     await handleConfirmPurchase({
  //       paymentMethod: "coins",
  //       cartItems: [{
  //         ID: product.id,
  //         quantity: 1,
  //         Amount: product.charm,
  //       }],
  //     });
  //
  //     showToast("🎉 Purchase with Gems successful!");
  //     console.log("[autoBuyWithGems] Purchase with Gems successful!");
  //   } catch (err) {
  //     showToast("Failed to purchase with Gems.");
  //     console.error("[autoBuyWithGems] Error:", err);
  //   } finally {
  //     setGemPurchaseLoading(false); // Reset loading state
  //   }
  // };

  return (
    <Container>
      {/* A-MU Hero Section */}
      <AmuHeroSection>
        <AmuHeroInner>
          <AmuHeroLeft>
            <AmuNavList>
              {amuNavItems.map((item) => (
                <AmuNavItem
                  key={item}
                  isActive={activeNavItem === item}
                  onClick={() => { setActiveNavItem(item); setSelectedCategoryId(item); }}
                >
                  {amuNavContent[item]?.navLabel}
                </AmuNavItem>
              ))}
            </AmuNavList>
            <AmuInfoBlock key={activeNavItem}>
              <AmuInfoTitle>{amuNavContent[activeNavItem]?.title}</AmuInfoTitle>
              <AmuInfoText>{amuNavContent[activeNavItem]?.text}</AmuInfoText>
            </AmuInfoBlock>
          </AmuHeroLeft>
          <AmuHeroRight>
            <AmuCardImage src={amuNavContent[activeNavItem]?.image || amulet} alt={amuNavContent[activeNavItem]?.title || 'Digital Piece'} />
          </AmuHeroRight>
        </AmuHeroInner>
      </AmuHeroSection>

      {/* Greeting Section */}
      <GreetingSection>
        {/* <GreetingTitle>
          {t('shop.greetingTitle') || 'XianHe Shop'}
        </GreetingTitle>
        <GreetingText dangerouslySetInnerHTML={{ __html: t('shop.greetingText') || 'Discover spiritually crafted amulets and digital charms — each blessed and designed to support your journey in health, wealth, love, and protection.' }} /> */}
        <img
          src={image}
          alt="XianHe Affiliate"
          style={{ marginTop: '10px', maxWidth: '600px', width: '100%', height: '40px', borderRadius: '12px', opacity: 0.1, color: '#3e363d' }}
        />
      </GreetingSection>

      <Content>
      <FilterBarWrapper>
          <FilterToggleRow>
            <SearchBox style={{ flex: 1, minWidth: 180 }}>
              <IoSearchOutline size={16} />
              <SearchInput
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder={t('shop.searchPlaceholder') || 'Search products...'}
                aria-label="Search products"
              />
            </SearchBox>
            <FilterToggleButton
              type="button"
              isActive={isFilterOpen}
              onClick={() => setIsFilterOpen((open) => !open)}
              aria-expanded={isFilterOpen}
            >
              <IoFilterOutline size={16} />
              {t('shop.filters') || 'Filters'}
              {activeFilterCount > 0 ? ` (${activeFilterCount})` : ''}
              {isFilterOpen ? <IoChevronUp size={14} /> : <IoChevronDown size={14} />}
            </FilterToggleButton>
            {activeFilterCount > 0 && (
              <Pill type="button" onClick={clearAllFilters}>
                {t('shop.clearFilters') || 'Clear Filters'}
              </Pill>
            )}
          </FilterToggleRow>

          {isFilterOpen && (
            <FilterPanel>
              <FilterGroup>
                <FilterGroupTitle>{t('shop.category') || 'Category'}</FilterGroupTitle>
                <FilterPillRow>
                  {categories.map((c) => (
                    <Pill
                      key={c.id}
                      type="button"
                      isActive={selectedCategoryId === c.id}
                      onClick={() => { setSelectedCategoryId(c.id); setActiveNavItem(c.id); }}
                    >
                      {translateShopLabel(c.desc)} ({c.count})
                    </Pill>
                  ))}
                </FilterPillRow>
              </FilterGroup>

              <FilterGroup>
                <FilterGroupTitle>{t('shop.priceRange') || 'Price Range'}</FilterGroupTitle>
                <PriceRangeRow style={{ padding: 0, margin: 0 }}>
                  <PriceInput
                    type="number"
                    min="0"
                    placeholder={t('shop.min') || 'Min'}
                    value={priceMinInput}
                    onChange={(e) => setPriceMinInput(e.target.value)}
                    aria-label="Minimum price"
                  />
                  <span style={{ color: '#dfbd69' }}>–</span>
                  <PriceInput
                    type="number"
                    min="0"
                    placeholder={t('shop.max') || 'Max'}
                    value={priceMaxInput}
                    onChange={(e) => setPriceMaxInput(e.target.value)}
                    aria-label="Maximum price"
                  />
                  <Pill type="button" onClick={applyPriceRange}>
                    {t('shop.apply') || 'Apply'}
                  </Pill>
                </PriceRangeRow>
              </FilterGroup>

              {availableLifeAreas.length > 0 && (
                <FilterGroup>
                  <FilterGroupTitle>{t('shop.lifeAreas') || 'Life Areas'}</FilterGroupTitle>
                  <FilterPillRow>
                    {availableLifeAreas.map((area) => (
                      <Pill
                        key={area}
                        type="button"
                        isActive={selectedLifeAreas.includes(area)}
                        onClick={() => toggleLifeArea(area)}
                      >
                        {translateShopLabel(area)}
                      </Pill>
                    ))}
                  </FilterPillRow>
                </FilterGroup>
              )}
            </FilterPanel>
          )}
        </FilterBarWrapper>

        {/* Category Title */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '8px', position: 'relative' }}>
          <div style={{ 
            height: '120px', /* Exactly half of the ideal image height */
            overflow: 'hidden',
            marginBottom: '-35px', /* Pulls the text overlapping the visible half slightly */
            opacity: 0.1,
            zIndex: 0 
          }}>
            <img 
              src={crown} 
              alt="Crown" 
              style={{ width: '200px', objectFit: 'contain', display: 'block' }} 
            />
          </div>
          <SectionTitle style={{ position: 'relative', zIndex: 1, margin: 0 }}>
            {amuNavContent[activeNavItem]?.title || t('shop.shop') || 'Shop'}
          </SectionTitle>
        </div>

        {/* Expiry Tabs */}
        <ExpiryTabsRow>
          {/* <TabButton
            type="button"
            isActive={selectedExpiryBucket === 'all'}
            onClick={() => { handleExpiryFilter('all'); }}
            aria-pressed={selectedExpiryBucket === 'all'}
          >
            {t('shop.all') || 'All'}
          </TabButton> */}
          {availableExpiryBuckets.map((bucket) => (
            <TabButton
              key={bucket}
              type="button"
              isActive={selectedExpiryBucket === bucket}
              onClick={() => { handleExpiryFilter(bucket); }}
              aria-pressed={selectedExpiryBucket === bucket}
            >
              {getExpiryLabel(bucket)}
            </TabButton>
          ))}
        </ExpiryTabsRow>

        {/* Sign In Modal */}
        {showSignInModal && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 10001,
            }}
            onClick={() => setShowSignInModal(false)}
          >
            <div
              style={{
                backgroundColor: "#1a1a1a",
                padding: "32px 28px 24px 28px",
                borderRadius: "15px",
                width: "400px",
                maxWidth: "90vw",
                color: "#DFBD69",
                position: "relative",
                boxShadow: "0px 4px 18px rgba(0,0,0,0.18)",
                textAlign: "center",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                onClick={() => setShowSignInModal(false)}
                style={{
                  position: "absolute",
                  top: "16px",
                  right: "16px",
                  background: "none",
                  border: "none",
                  color: "#DFBD69",
                  fontSize: "1.8rem",
                  fontWeight: "bold",
                  cursor: "pointer",
                  zIndex: 2,
                }}
                aria-label="Close"
              >
                ×
              </button>
              <h2 style={{ color: "#DFBD69", marginBottom: "18px" }}>
                {t('shop.signInRequired') || 'Sign In Required'}
              </h2>
              <div style={{ marginBottom: "24px", color: "#ccc", fontSize: "1rem" }}>
                {t('shop.signInMessage') || 'Please sign in to add items to cart or make purchases.'}
              </div>
              <button
                style={{
                  background: "#DFBD69",
                  color: "#111",
                  border: "none",
                  borderRadius: "8px",
                  padding: "12px 32px",
                  fontWeight: "bold",
                  fontSize: "1rem",
                  cursor: "pointer",
                  transition: "background .2s",
                }}
                onMouseEnter={(e) => e.target.style.background = "#c9a860"}
                onMouseLeave={(e) => e.target.style.background = "#DFBD69"}
                onClick={() => setShowSignInModal(false)}
              >
                {t('shop.close') || 'Close'}
              </button>
            </div>
          </div>
        )}

        <ProductListContainer className="shop-product-list">
          <ProductList>
{(selectedCategoryId === WHEEL_CATEGORY_ID ? filteredWheelItems.length > 0 : filteredProducts.length > 0) ? (
              (selectedCategoryId === WHEEL_CATEGORY_ID ? filteredWheelItems : paginatedProducts).map((product) => (
                <ProductCard
                  key={product.id}
                  onMouseEnter={() => {
                    setHoveredProduct(product.id);
                  }}
                  onMouseLeave={() => {
                    setHoveredProduct(null);
                    if (!isTouchDevice) setActiveGif(null);
                  }}
                  onClick={(e) => {
                    // Browsing the overview is open to everyone; the buy/cart
                    // actions inside the modal still require sign-in.
                    const primary = product.hoverImage || product.image;
                    const isGif = /\.gif($|\?)/i.test(primary || "");
                    if (isTouchDevice && isGif) {
                      if (activeGif !== product.id) {
                        e.preventDefault();
                        e.stopPropagation();
                        setActiveGif(product.id);
                        return;
                      }
                    }
                    openProduct(product);
                    // navigate(`/product/${product.id}`, {
                    //   state: {
                    //     image:
                    //       product.ImageUrl ||
                    //       product.image ||
                    //       product.raw?.ImageUrl ||
                    //       "",
                    //     productRaw: product.raw,
                    //   },
                    // });
                    // console.log("Navigate to product id:", product.id);
                  }}
                  style={{
                    position: "relative",
                    opacity: 1,
                    cursor: "pointer",
                  }}
                >
                  <ImageWrapper>
                    {(() => {
                      const primary = product.hoverImage || product.image;
                      const isGif = /\.gif($|\?)/i.test(primary || "");
                      const isPlaying =
                        hoveredProduct === product.id ||
                        activeGif === product.id;
                      if (isGif) {
                        return (
                          <>
                            <HoverGif
                              src={primary}
                              alt={product.desc_oth}
                              isHovered={isPlaying}
                              thumbSrc={product.thumb}
                            />
                            {/* {isTouchDevice && !isPlaying && (
                              <div
                                style={{
                                  position: "absolute",
                                  bottom: 6,
                                  right: 6,
                                  background: "rgba(0,0,0,0.55)",
                                  color: "gold",
                                  fontSize: 11,
                                  padding: "4px 8px",
                                  borderRadius: 20,
                                  pointerEvents: "none",
                                  letterSpacing: ".5px",
                                }}
                              >
                                {t('shop.tapToPlay') || 'Tap to Play'}
                              </div>
                            )} */}
                          </>
                        );
                      }
                      return (
                        <ProductImage
                          loading="lazy"
                          src={
                            hoveredProduct === product.id
                              ? product.hoverImage
                              : product.image
                          }
                          alt={product.desc_oth}
                        />
                      );
                    })()}

                    {/* Lock icon overlay when not logged in */}
                    {!isLoggedIn && (
                      <div
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                          fontSize: "48px",
                          color: "#DFBD69",
                          opacity: 0.8,
                          pointerEvents: "none",
                        }}
                      >
                        
                      </div>
                    )}

                    {/* <IconOverlay>
                      <Button
                        aria-label={`Add ${product.desc_oth} to cart`}
                        onClick={(e) => {
                          e.stopPropagation();
                          addToCart(product);
                        }}
                        disabled={!isLoggedIn}
                        style={{
                          opacity: isLoggedIn ? 1 : 0.5,
                          cursor: isLoggedIn ? "pointer" : "not-allowed",
                        }}
                      >
                        <FaCartPlus />
                      </Button>
                    </IconOverlay> */}
                  </ImageWrapper>
                  <ProductName
                    title={product.desc_oth}
                    aria-label={product.desc_oth}
                  >
                    {product.desc_oth.split("\n").map((line, idx, arr) => (
                      <React.Fragment key={idx}>
                        {line}
                        {idx < arr.length - 1 && <br />}
                      </React.Fragment>
                    ))}
                  </ProductName>
                  <p
                    style={{
                      fontSize: "clamp(14px, 1vw, 16px)",
                      fontFamily: "'DMSans', sans-serif",
                      fontWeight: "400",
                      color: "#fff2d2",
                      opacity: 1,
                      lineHeight: "20px",
                      /* Clamp by lines, not by character count: a character
                         budget tuned for English overflows in id/cn. */
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      WebkitLineClamp: 2,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      wordBreak: "break-word",
                      width: "100%",
                      maxWidth: "344px",
                      margin: "0 auto 50px",
                    }}
                    title={product.details}
                  >
                    {product.details}
                  </p>

                  {/* Bottom buttons */}
                  <div
                    style={{
                      width: "100%",
                      marginTop: "auto",
                      paddingTop: "8px",
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "8px",
                    }}
                  >
                    {/* Bottom buttons */}
                    <div
                      style={{
                        width: "100%",
                        maxWidth: "344px",
                        margin: "auto auto 0",
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "10px",
                        paddingBottom: "4px",
                        borderTop: "1px solid rgba(212,175,55,0.2)",
                        paddingTop: "12px",
                      }}
                    >
                      <Button
                        aria-label={isLoggedIn ? `Price: ${product.price}` : "Sign in to purchase"}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!isLoggedIn) return;
                          setConfirmAddToCartModal({ show: true, product });
                        }}
                        disabled={!isLoggedIn}
                        style={{
                          flex: 1,
                          height: 38,
                          borderRadius: 10,
                          fontSize: "clamp(14px, 1vw, 20px)",
                          fontWeight: 600,
                          fontFamily: "'DMSans', sans-serif",
                          background: '#deaf77',
                          color: '#200d3c',
                          border: 'none',
                          opacity: isLoggedIn ? 1 : 0.5,
                          cursor: isLoggedIn ? "pointer" : "not-allowed",
                        }}
                      >
                        ${`${product.price}`}
                      </Button>
                      <Button
                        aria-label={isLoggedIn ? `Gems: ${product.charm}` : "Sign in to purchase"}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!isLoggedIn) {
                            alert("Please sign in to purchase with Gems.");
                            return;
                          }
                          setConfirmAddToCartModal({ show: true, product });
                        }}
                        disabled={!isLoggedIn}
                        style={{
                          flex: 1,
                          height: 38,
                          borderRadius: 10,
                          fontSize: "clamp(13px, 1vw, 20px)",
                          fontWeight: 600,
                          fontFamily: "'DMSans', sans-serif",
                          background: '#0a031e',
                          color: '#deaf77',
                          border: '1px solid #c9a84b',
                          opacity: isLoggedIn ? 1 : 0.5,
                          cursor: isLoggedIn ? "pointer" : "not-allowed",
                        }}
                      >
                        <img src={gem} alt="Gem" style={{ width: 16, height: 16, marginRight: 8, transform: `rotate(330deg)` }} />
                        {product.charm} Gem
                      </Button>
                    </div>
                  </div>
                </ProductCard>
              ))
            ) : (
              <p style={{ color: '#DFBD69', gridColumn: '1 / -1' }}>{t("shop.noProductMessage")}</p>
            )}
          </ProductList>

          {/* Pagination */}
          {selectedCategoryId !== WHEEL_CATEGORY_ID && totalPages > 1 && (
            <PaginationRow>
              <PageButton
                onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                disabled={currentPage === 1}
                aria-label="Previous page"
              >
                <img src={leftarrow} alt="Previous page" style={{ width: 12, height: 12, marginLeft: 2 }} />
              </PageButton>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <PageButton
                  key={page}
                  isActive={page === currentPage}
                  onClick={() => setCurrentPage(page)}
                  aria-label={`Page ${page}`}
                  aria-current={page === currentPage ? 'page' : undefined}
                >
                  {page}
                </PageButton>
              ))}
              <PageButton
                onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                disabled={currentPage === totalPages}
                aria-label="Next page"
              >
                <img src={rightarrow} alt="Next page" style={{ width: 12, height: 12, marginLeft: 2 }} />
              </PageButton>
            </PaginationRow>
          )}
        </ProductListContainer>
      </Content>

      {confirmAddToCartModal.show && confirmAddToCartModal.product && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(0,0,0,0.5)", zIndex: 99999,
            display: "flex", alignItems: "center", justifyContent: "center",
            overflowY: "auto", WebkitOverflowScrolling: "touch",
          }}
          onClick={() => setConfirmAddToCartModal({ show: false, product: null })}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#111", color: "#deaf77", borderRadius: 12, padding: 24,
              width: "min(420px, 92vw)", textAlign: "center", boxShadow: "0 4px 24px rgba(0,0,0,0.3)",
            }}
          >
            <h3 style={{ margin: "0 0 12px" }}>{t("shop.confirmAddToCart") || "Add to Cart"}</h3>
            <p style={{ color: "#fff2d2", marginBottom: 18 }}>
              {t("shop.confirmAddToCartMessage", { productName: confirmAddToCartModal.product.desc_oth }) ||
                `Are you sure you want to add "${confirmAddToCartModal.product.desc_oth}" to your cart?`}
            </p>
            <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
              <button
                style={{
                  background: "#deaf77", color: "#200d3c", border: "none",
                  borderRadius: 6, padding: "8px 18px", fontWeight: 600, cursor: "pointer",
                }}
                onClick={() => {
                  const product = confirmAddToCartModal.product;
                  setConfirmAddToCartModal({ show: false, product: null });
                  addToCart(product);
                }}
              >
                {t("shop.yes") || "Yes, Add"}
              </button>
              <button
                style={{
                  background: "#333", color: "#deaf77", border: "none",
                  borderRadius: 6, padding: "8px 18px", cursor: "pointer",
                }}
                onClick={() => setConfirmAddToCartModal({ show: false, product: null })}
              >
                {t("shop.cancel") || "Cancel"}
              </button>
            </div>
          </div>
        </div>
      )}
      {toastMessage && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#10b981",
            color: "#fff",
            padding: "12px 20px",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            zIndex: 9999,
            transition: "opacity 0.3s ease-in-out",
          }}
        >
          {toastMessage}
        </div>
      )}
      {txnStatusModal.show && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.65)",
            // Higher than the Stripe modal's portal (zIndex 9999999) so the
            // outcome is visible even if it resolves while that modal is open.
            zIndex: 100000000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 16,
          }}
        >
          <div
            style={{
              background: "#111",
              color: "#DFBD69",
              borderRadius: 12,
              padding: "28px 24px",
              width: "min(400px, 92vw)",
              textAlign: "center",
              boxShadow: "0 4px 24px rgba(0,0,0,0.4)",
            }}
          >
            {(txnStatusModal.phase === "processing" || txnStatusModal.phase === "slow") && <TxnSpinner />}
            {txnStatusModal.phase === "success" && <div style={{ fontSize: 40, marginBottom: 8 }}>✅</div>}
            {txnStatusModal.phase === "error" && <div style={{ fontSize: 40, marginBottom: 8 }}>❌</div>}
            {txnStatusModal.phase === "unknown" && <div style={{ fontSize: 40, marginBottom: 8 }}>⚠️</div>}
            <p style={{ margin: 0, lineHeight: 1.5 }}>{txnStatusModal.message}</p>
            {txnStatusModal.phase !== "processing" && txnStatusModal.phase !== "slow" && (
              <button
                onClick={() => setTxnStatusModal({ show: false, phase: "processing", message: "" })}
                style={{
                  marginTop: 18,
                  background: "#DFBD69",
                  color: "#111",
                  border: "none",
                  borderRadius: 6,
                  padding: "8px 22px",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                {t("shop.ok") || "OK"}
              </button>
            )}
          </div>
        </div>
      )}
      {stripeModalOpen && (
        <StripePayment
          id={userID}
          amount={stripeAmount}
          currency="usd"
          isOpen={stripeModalOpen}
          onClose={() => setStripeModalOpen(false)}
          onPaymentSuccess={async () => {
            console.log("[StripePayment] Payment success for product:", stripeProduct);
            try {
              if (stripeProduct?.categoryId === WHEEL_CATEGORY_ID) {
                // Wheel/draw items: call StickPurchase after Stripe payment succeeds
                console.log("[StripePayment] Calling StickPurchase (pay_mode=1) for draw:", stripeProduct);
                await runTransaction(
                  async () => {
                    const res = await fetchWithTimeout(
                      `https://xianhefairy.com/LotusFairy_API/api/draws/StickPurchase?CustId=${userID}&pay_mode=1`,
                      {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify([{ Id: stripeProduct.id, Qty: 1 }]),
                      },
                      TXN_TIMEOUT_MS
                    );
                    const body = await res.json().catch(() => null);
                    console.log("[StripePayment] StickPurchase response:", res.status, body);
                    if (!res.ok) throw new Error("StickPurchase failed");
                    return body;
                  },
                  {
                    successMessage: t("shop.stripeSuccess") || "🎉 Stripe payment successful!",
                    // Stripe already charged the card by this point, so a failure here
                    // means our order recording failed, not the payment itself.
                    errorMessage:
                      t("shop.stripeOrderError") ||
                      "⚠️ Payment received, but we couldn't confirm your order. Please contact support.",
                    unknownMessage:
                      t("shop.stripeOrderUnknown") ||
                      "⚠️ Payment received, but confirming your order is taking too long due to a connection issue. Please check your draws in a moment, or contact support if they don't appear.",
                  }
                );
                window.dispatchEvent(new CustomEvent("gemsUpdated"));
              } else {
                await handleConfirmPurchase({
                  paymentMethod: "stripe",
                  cartItems: [{
                    ID: stripeProduct.id,
                    quantity: 1,
                    Amount: stripeProduct.price,
                  }],
                });
              }
              console.log("[StripePayment] Purchase with Stripe successful!");
            } catch (err) {
              // runTransaction/handleConfirmPurchase already surfaced the failure
              // via the transaction status modal, so there's nothing more to show here.
              console.error("[StripePayment] Post-payment processing failed:", err);
            } finally {
              setStripeModalOpen(false);
            }
          }}
          product={stripeProduct}
        />
      )}
      {confirmGemModal.show && confirmGemModal.product && (
        <div style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          background: "rgba(0,0,0,0.5)", zIndex: 99999,
          display: "flex", alignItems: "center", justifyContent: "center",
          overflowY: "auto", WebkitOverflowScrolling: "touch"
        }}>
          <div style={{
            background: "#111", color: "#DFBD69", borderRadius: 12, padding: 24, width: "min(500px, 92vw)", textAlign: "center", boxShadow: "0 4px 24px rgba(0,0,0,0.3)"
          }}>
            <h3>{t("shop.confirmPurchase")}</h3>
            <p>
              {t("shop.confirmPurchaseMessage", {
                productName: confirmGemModal.product.desc_oth,
                gemCost: confirmGemModal.product.charm,
              })}
            </p>
            <div style={{ marginTop: 18, display: "flex", gap: 12, justifyContent: "center" }}>
              <button
                disabled={gemPurchaseLoading}
                style={{
                  background: gemPurchaseLoading ? "#888" : "#DFBD69",
                  color: "#111",
                  border: "none",
                  borderRadius: 6,
                  padding: "8px 18px",
                  fontWeight: 600,
                  cursor: gemPurchaseLoading ? "not-allowed" : "pointer",
                  opacity: gemPurchaseLoading ? 0.7 : 1
                }}
                onClick={async () => {
                  const product = confirmGemModal.product;
                  setConfirmGemModal({ show: false, product: null });
                  await addToCart(product);
                }}
              >
                {gemPurchaseLoading ? t("shop.processing") || "Processing..." : t("shop.buy")}
              </button>
              <button
                disabled={gemPurchaseLoading}
                style={{ background: "#333", color: "#DFBD69", border: "none", borderRadius: 6, padding: "8px 18px", cursor: gemPurchaseLoading ? "not-allowed" : "pointer" }}
                onClick={() => setConfirmGemModal({ show: false, product: null })}
              >
                {t("shop.cancel")}
              </button>
            </div>
          </div>
        </div>
      )}
      {confirmPurchaseModal.show && confirmPurchaseModal.product && (
        <div style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          background: "rgba(0,0,0,0.5)", zIndex: 99999,
          display: "flex", alignItems: "center", justifyContent: "center",
          overflowY: "auto", WebkitOverflowScrolling: "touch"
        }}>
          <div style={{
            background: "#111", color: "#deaf77", borderRadius: 12, padding: 24, width: "min(500px, 92vw)", textAlign: "center", boxShadow: "0 4px 24px rgba(0,0,0,0.3)"
          }}>
            <h3 style={{ margin: "0 0 12px" }}>{t("shop.confirmPurchase") || "Confirm Purchase"}</h3>
            <p style={{ color: "#fff2d2", marginBottom: 18 }}>
              {t("shop.confirmPurchaseUSDMessage", {
                productName: confirmPurchaseModal.product.desc_oth,
                price: confirmPurchaseModal.product.price,
              }) || `Purchase ${confirmPurchaseModal.product.desc_oth} for $${confirmPurchaseModal.product.price}?`}
            </p>
            <div style={{ marginTop: 18, display: "flex", gap: 12, justifyContent: "center" }}>
              <button
                style={{
                  background: "#deaf77",
                  color: "#200d3c",
                  border: "none",
                  borderRadius: 6,
                  padding: "8px 18px",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
                onClick={async () => {
                  const product = confirmPurchaseModal.product;
                  setConfirmPurchaseModal({ show: false, product: null });
                  await addToCart(product);
                }}
              >
                {t("shop.buy") || "Buy"}
              </button>
              <button
                style={{ background: "#333", color: "#deaf77", border: "none", borderRadius: 6, padding: "8px 18px", cursor: "pointer" }}
                onClick={() => setConfirmPurchaseModal({ show: false, product: null })}
              >
                {t("shop.cancel") || "Cancel"}
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Guardian Confirmation Modal (for users under 18 attempting card payment) */}
      {guardianModal.show && (
        <div
          style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.75)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 99998 }}
          onClick={() => setGuardianModal({ show: false, pendingProduct: null })}
        >
          <div
            style={{ backgroundColor: "#1a1a1a", borderRadius: 12, padding: "28px 24px", width: "min(460px, 92vw)", textAlign: "center", boxShadow: "0 8px 32px rgba(0,0,0,0.45)", border: "1px solid rgba(223,189,105,0.25)" }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 style={{ color: "#DFBD69", margin: "0 0 16px", fontSize: "1.2rem" }}>{t("cart.guardianConfirmationRequired")}</h3>
            <p style={{ color: "#fff2d2", marginBottom: 28, lineHeight: 1.6 }}>{t("cart.guardianMessage")}</p>
            <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
              <button
                style={{ background: "#DFBD69", color: "#151517", border: "none", borderRadius: 8, padding: "10px 22px", fontWeight: 700, cursor: "pointer", fontSize: "0.95rem" }}
                onClick={() => {
                  const product = guardianModal.pendingProduct;
                  setGuardianModal({ show: false, pendingProduct: null });
                  if (product) {
                    setStripeAmount(product.price);
                    setStripeProduct(product);
                    setStripeModalOpen(true);
                  }
                }}
              >
                {t("cart.yesProceed")}
              </button>
              <button
                style={{ background: "transparent", color: "#DFBD69", border: "1px solid rgba(223,189,105,0.4)", borderRadius: 8, padding: "10px 22px", cursor: "pointer", fontSize: "0.95rem" }}
                onClick={() => setGuardianModal({ show: false, pendingProduct: null })}
              >
                {t("cart.noCancel")}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Buy Options Chooser: Card vs Gems */}
      {showBuyOptions && selectedProduct && (
        <div style={{
          position: "fixed",
          top: 0, left: 0, right: 0, bottom: 0,
          background: "rgba(0,0,0,0.6)", zIndex: 10005,
          display: "flex", alignItems: "center", justifyContent: "center",
        }}
          onClick={() => setShowBuyOptions(false)}
        >
          <div onClick={(e) => e.stopPropagation()} style={{
            background: "#111", color: "#DFBD69", padding: 20, borderRadius: 12, width: "min(420px, 92vw)", textAlign: "center", boxShadow: "0 8px 24px rgba(0,0,0,0.4)"
          }}>
            <h3 style={{ margin: 0, marginBottom: 12 }}>{t('shop.choosePayment') || 'Choose payment method'}</h3>
            <p style={{ color: '#ccc', marginBottom: 16 }}>{selectedProduct.desc_oth}</p>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
              <button
                onClick={() => {
                  // Card
                  setShowBuyOptions(false);
                  closeProduct();
                  addToCart(selectedProduct);
                }}
                style={{ background: '#deaf77', color: '#0a031e', border: 'none', padding: '10px 18px', borderRadius: 8, fontWeight: 700, cursor: 'pointer' }}
              >
                {t('shop.buyWithCard') || 'Buy with Card'}
              </button>
              <button
                onClick={() => {
                  // Gems
                  setShowBuyOptions(false);
                  setConfirmGemModal({ show: true, product: selectedProduct });
                }}
                style={{ background: '#0a031e', color: '#deaf77', border: '1px solid #c9a84b', padding: '10px 18px', borderRadius: 8, fontWeight: 700, cursor: 'pointer' }}
              >
                {t('shop.buyWithGems') || 'Buy with Gems'}
              </button>
            </div>
            <button onClick={() => setShowBuyOptions(false)} style={{ marginTop: 12, background: 'transparent', border: 'none', color: '#ccc', cursor: 'pointer' }}>{t('shop.cancel') || 'Cancel'}</button>
          </div>
        </div>
      )}
      {/* Product Overview Modal */}
      {selectedProduct && (
        <div
          style={{
            position: "fixed",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(0,0,0,0.7)",
            zIndex: 30000,
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "center",
            padding: "calc(env(safe-area-inset-top, 0px) + 32px) 16px 16px",
            boxSizing: "border-box",
            overflowY: "auto",
            WebkitOverflowScrolling: "touch",
          }}
          onClick={() => closeProduct()}
        >
          <div
            style={{
              background: "#171520",
              border: "2px solid rgba(201,168,75,0.4)",
              borderRadius: "14px",
              width: "min(930px, 100%)",
              maxHeight: "calc(100vh - 32px)",
              overflowY: "auto",
              WebkitOverflowScrolling: "touch",
              position: "relative",
              margin: "auto",
              boxShadow: "0 8px 32px rgba(0,0,0,0.6)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "14px 20px",
              // borderBottom: "1px solid rgba(201,168,75,0.3)",
            }}>
              <span style={{ color: "#deaf77", fontWeight: 700, fontFamily: "'PlayfairDisplay', sans-serif", fontSize: "22px", lineHeight: "22px", marginTop: "10px" }}>
                Product Overview
              </span>
              <button
                onClick={() => closeProduct()}
                style={{
                  background: "none", border: "none",
                  color: "#deaf77", fontSize: "22px",
                  cursor: "pointer", lineHeight: 1, padding: 0,
                }}
                aria-label="Close"
              ><img src={close} alt="Close" style={{ width: 20, height: 20, pointerEvents: "none" }} /></button>
              
            </div>

            {/* Body */}
            <div style={{ padding: "20px" }}>
              {/* Top row: image + info */}
              <div style={{ display: "flex", gap: "20px", alignItems: "stretch", flexWrap: "wrap" }}>
                {/* Product image */}
                <div style={{
                  width: "min(320px, 100%)", aspectRatio: "8 / 9", flexShrink: 0,
                  borderRadius: "10px", overflow: "hidden",
                  background: "#0a031e", border: "1px solid rgba(201,168,75,0.2)",
                }}>
                  <img
                    src={selectedProduct.image || selectedProduct.hoverImage || selectedProduct.ImageUrl || ""}
                    alt={selectedProduct.desc_oth}
                    style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "10px" }}
                  />
                </div>

                {/* Info column */}
                <div style={{ flex: 1, minWidth: "200px", display: "flex", flexDirection: "column" }}>
                  <h3 style={{
                    color: "#deaf77", fontFamily: "'PlayfairDisplay', serif",
                    fontWeight: 700, fontSize: "clamp(22px, 2.2vw, 30px)", margin: "0 0 10px", lineHeight: 1.2,
                  }}>
                    {selectedProduct.desc_oth}
                  </h3>
                  <p style={{
                    color: "#fff2d2", fontFamily: "'DMSans', sans-serif",
                    fontSize: "clamp(15px, 1.2vw, 20px)", lineHeight: 1.4, margin: "0 0 24px", fontWeight: 400,
                  }}>
                    {selectedProduct.details}
                  </p>

                  {/* Bottom group: icons + price + buttons */}
                  <div style={{ marginTop: "auto", display: "flex", flexDirection: "column", gap: "16px" }}>
                    {/* Social icons */}
                    <div style={{ display: "flex", gap: "10px" }}>
                      {selectedProduct.raw?.FACEBOOK ? (
                        <a href={selectedProduct.raw.FACEBOOK} target="_blank" rel="noopener noreferrer">
                          <img src={facebook} alt="Facebook" style={{ width: 28, height: 28, objectFit: "contain" }} />
                        </a>
                      ) : <img src={facebook} alt="Facebook" style={{ width: 28, height: 28, objectFit: "contain", opacity: 1 }} />}
                      {selectedProduct.raw?.INSTAGRAM ? (
                        <a href={selectedProduct.raw.INSTAGRAM} target="_blank" rel="noopener noreferrer">
                          <img src={instagram} alt="Instagram" style={{ width: 28, height: 28, objectFit: "contain" }} />
                        </a>
                      ) : <img src={instagram} alt="Instagram" style={{ width: 28, height: 28, objectFit: "contain", opacity: 1 }} />}
                      {selectedProduct.raw?.YOUTUBE ? (
                        <a href={selectedProduct.raw.YOUTUBE} target="_blank" rel="noopener noreferrer">
                          <img src={youtube} alt="YouTube" style={{ width: 28, height: 28, objectFit: "contain" }} />
                        </a>
                      ) : <img src={youtube} alt="YouTube" style={{ width: 28, height: 28, objectFit: "contain", opacity: 1 }} />}
                    </div>

                    {/* Price row */}
                    <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                      <span style={{ color: "#deaf77", fontFamily: "'DMSans', sans-serif", fontWeight: 600, fontSize: "17px" }}>
                         ${selectedProduct.price}
                      </span>
                      <span style={{ color: "#deaf77", fontFamily: "'DMSans', sans-serif", fontWeight: 600, fontSize: "17px", display: "flex", alignItems: "center", gap: "5px" }}>
                        <img src={gem} alt="Gem" style={{ width: 15, height: 15, transform: "rotate(330deg)" }} />
                        {selectedProduct.charm} Gem
                      </span>
                    </div>

                    {/* Action buttons */}
                    <div style={{ display: "flex", gap: "12px" }}>
                      <button
                        style={{
                          flex: 1, padding: "10px 0",
                          background: "#0a031e", color: "#deaf77",
                          border: "1px solid #c9a84b", borderRadius: "8px",
                          fontWeight: 600, fontFamily: "'DMSans', sans-serif", fontSize: "15px",
                          cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px",
                        }}
                        onClick={() => { setConfirmAddToCartModal({ show: true, product: selectedProduct }); closeProduct(); }}
                      >
                        <FaCartPlus /> {t("productListPage.addToCart")}
                      </button>
                      {/* <button
                        style={{
                          flex: 1, padding: "10px 0",
                          background: "#deaf77", color: "#0a031e",
                          border: "none", borderRadius: "8px",
                          fontWeight: 600, fontFamily: "'DMSans', sans-serif", fontSize: "15px",
                          cursor: "pointer",
                        }}
                        onClick={() => { setShowBuyOptions(true); }}
                      >
                        {t("productListPage.buyNow")}
                      </button> */}
                    </div>
                  </div>
                </div>
              </div>

              {/* Introduction section */}
              <div style={{ marginTop: "22px" }}>
                <div style={{
                  color: "#deaf77", fontFamily: "'PlayfairDisplay', sans-serif",
                  fontWeight: 700, fontSize: "18px", marginBottom: "12px", lineHeight: "18px",
                  borderBottom: "1px solid rgba(201,168,75,0.4)", paddingBottom: "6px",
                }}>
                  Introduction
                </div>
                <div style={{
                  border: "1px dashed rgba(201,168,75,0.4)", borderRadius: "8px",
                  padding: "16px", background: "#0a031e",
                  color: "#fff2d2", fontFamily: "'DMSans', sans-serif",
                  fontSize: "14px", lineHeight: 1.6, minHeight: "270px",
                }}
                  dangerouslySetInnerHTML={{
                    __html: selectedProduct.raw?.INTRO_DESC || selectedProduct.raw?.INTRO || selectedProduct.details || ""
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </Container>
  );
}
const styles = {
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContent: {
    backgroundColor: "black",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    width: "300px",
    textAlign: "center",
  },
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    backgroundColor: "transparent",
    border: "none",
    fontSize: "24px",
    cursor: "pointer",
  },
  checkboxContainer: {
    marginTop: "15px",
    marginBottom: "15px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  confirmButton: {
    padding: "10px 20px",
    fontSize: "16px",
    borderRadius: "5px",
    border: "none",
    marginRight: "10px",
  },
};

export default Shop;
